/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 8/20/18 2:14 PM
 * Created by kxian
 *
 */

import React from "react";

class DevWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    toggleWidget = (e) => {
        $('.dev-info-widget').toggleClass('active');
        e.preventDefault();
    };

    copyToClipboard = (e) => {
        const text = $('.dev-info-widget pre').html();
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    console.log('Copied to clipboard');
                })
                .catch(e => {
                    console.log('Could not copy to clipboard, ', e);
                });
        } else {
            console.log("Can't copy, not clipboard interface");
        }
        e.preventDefault();
    };

    render() {
        const state = this.props.state,
            data = state.data;
        return (
            <div className="dev-info-widget">
                <a href="#" onClick={this.toggleWidget}
                   className="dev-info-toggle">

                    <i className="material-icons">expand_less</i>
                </a>
                <div className="dev-info-content">
                    Current State: {' '}
                    <a href="#" onClick={this.copyToClipboard} title="Copy to clipboard">
                        <i className="fa fa-clipboard" aria-hidden="true"><span className="sr-only">Copy to clipboard</span></i>
                    </a>
                    <pre>{JSON.stringify(data, null, 2)}</pre>
                </div>
            </div>
        );
    }
}
export default DevWidget;
